export const packageList = [
  {
    name: 'allocation',
    activeRule: ['auto', 'trunk', 'pz-new', 'pz', 'allocation-route', 'pznew'], // pznew -> pz-new 用layout编码代替路由
  }
]

export const remoteModuleConfig = {
  dev: ['allocation'],
  stg: ['allocation'],
  uat: ['allocation'],
  prd: ['allocation'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/allocation/index.js